import {gql} from '@apollo/client';
import {ComplaintAppealDetail} from '../types/CustomerComplaintType';

const COMPLAINT_APPEAL_DETAIL_FIELDS = `
    id
    complaintId
    reviewTaskId
    appealReason {
        text
        lang
        translations {
            lang
            text
        }
    }
    appealAttachmentS3UrlsJson
    appealSubmittedAt
    appealSubmittedBy
    appealSubmitterName
    reviewResult
    reviewerId
    reviewComment {
        tagKeys
        tagOptions {
            code
            displayOrder
            texts {
                lang
                text
            }
        }
        text
        lang
        translations {
            lang
            text
        }
    }
    reviewedAt
`;

export const GET_COMPLAINT_APPEAL_DETAIL = gql`
    query GetComplaintAppealDetail($complaintId: Long!) {
        getCustomerComplaintAppealDetailByComplaintId(complaintId: $complaintId) {
            ${COMPLAINT_APPEAL_DETAIL_FIELDS}
        }
    }
`;

export interface GetComplaintAppealDetailResponse {
    getCustomerComplaintAppealDetailByComplaintId?: ComplaintAppealDetail;
}

export interface GetComplaintAppealDetailVariables {
    complaintId: number;
}
